module.exports = __webpack_public_path__ + "static/img/jjc_dfs_honor.1c6fb486.png";